(function () {
  const $ = require('jQuery');
  const widgets = require('../../legacy/widgets');
  const icons = require('../../icons');
  const machinemotion = require('../../api/machinemotion');
  const machinelogic = require('../../machinelogic');
  const environment = require('../../environment');
  require('./uiBuilder.css');

  const gGridHeight     = machinelogic.uiWidgetDimensions.gridHeight;
  const gGridWidth      = machinelogic.uiWidgetDimensions.gridWidth;
  const gGridCellWidth  = machinelogic.uiWidgetDimensions.gridCellWidth;
  const gGridCellHeight = machinelogic.uiWidgetDimensions.gridCellHeight;
  const gCellGutter     = machinelogic.uiWidgetDimensions.cellGutter;

  // Note (mkosarek): renderUiBase renders the the user interface for display purposes only.
  // renderUiEdit builds on top of renderUi to allow users to drag, drop and edit widgets.
  // renderUiPlay builds on top of renderUi and also hooks up the rendered UI to the execution engine.
  function renderUiBase(pLibrary, pApplication, pUI) {
    const lUiContainer = $('<div>');
    const lUiContent = $('<div>');
    const lHeaderArea = $('<div class="h_layout space-between ml_ui_builder_header">');
    const lTitle = $('<h3>').text(pApplication.getName() + ' UI');
    const lTabBar = $('<div class="h_layout ml_ui_builder_tab_area">');
    const lWidgetWrapper = $('<div>');
    const lWidgetContainer = $('<div>');

    if (pUI.useFullUiSpace()) {
      lUiContainer.addClass('ml_ui_builder_container_full_length');
      lUiContent.addClass('ml_ui_builder_content');
      lWidgetWrapper.addClass('ml_ui_builder_widget_area_full_length');
      lWidgetContainer.addClass('ml_ui_builder_widget_container_full_length');
    } else {
      lUiContainer.addClass('ml_ui_builder_container');
      lWidgetWrapper.addClass('ml_ui_builder_widget_area');
      lWidgetContainer.addClass('ml_ui_builder_widget_container');
    }

    let lActiveTabIndex = 0;
    const lAddTab = function(pTab, pTabIndex) {
      const lTabInput = $('<input type="text" maxlength="12" value="' + pTab.getName() + '" >').hide();
      const lTabLabel = $('<div/>').text(pTab.getName());
      const lTabElement = $('<div class="ml_ui_builder_tab">').on('click', function() {
        if(pTab !== pUI.getSelectedTab()) {
          lOpenTab(lTabElement.index());
        }
      }).append([lTabLabel, lTabInput]);

      lTabBar.append(lTabElement);

      if ((pUI.getSelectedTab() == undefined && pTabIndex == 0) || pUI.getSelectedTab() == pTab) {
        lOpenTab(pTabIndex);
      }

      return lTabElement;
    };
    const lOpenTab = function(pTabIndex) {
      lActiveTabIndex = pTabIndex;
      lWidgetContainer.find('.ml_ui_builder_widget').remove();
      const lTab = pUI.listTabs()[pTabIndex];
      if (!lTab) {
        console.error('Tab not found, index=' + pTabIndex);
        return;
      }

      lTab.listWidgets().forEach(function(pWidget, pWidgetIndex) {
        const lWidgetRender = renderWidget(pApplication, pUI, pWidget, pWidgetIndex, pLibrary);
        if (!lWidgetRender) {
          return;
        }

        lWidgetContainer.append(lWidgetRender);
      });

      lTabBar.children().removeClass('selected');
      lTabBar.children().eq(pTabIndex).addClass('selected');
      pUI.selectTab(pTabIndex);
    };
    const lDeleteTab = function(pTab, pTabIndex) {
      lTabBar.children().eq(pTabIndex).remove();
      const _lRemainingTabs = pUI.listTabs();
      if (pTabIndex == lActiveTabIndex) { // The deleted tab was open
        if (lActiveTabIndex == _lRemainingTabs.length) { // The deleted tab was the last tab
          if (_lRemainingTabs.length == 0) {
            lActiveTabIndex = 0;
            console.error('Tab length should never be zero, this is a bug.');
          } else {
            lOpenTab(_lRemainingTabs.length - 1);
          }
        } else {
          lOpenTab(lActiveTabIndex); // Open the tab that took its spot
        }
      } else if (pTabIndex < lActiveTabIndex) {
        lActiveTabIndex--;
      }
    };

    // Construct the tab list
    pUI.listTabs().forEach(lAddTab);

    // Define functions on the ui
    lUiContainer.getActiveTabIndex = function() {
      return lActiveTabIndex;
    };

    // Define listener
    const lUiListener = {
      onTabAdded: function(pTab, pTabIndex) {
        lAddTab(pTab, pTabIndex);
      },
      onTabRemoved: function(pTab, pTabIndex) {
        lDeleteTab(pTab, pTabIndex);
      },
    };

    pUI.addListener(lUiListener);

    return lUiContainer.append(
      lUiContent.append(
        lHeaderArea.append(
          lTitle,
        ),
        lTabBar,
        lWidgetWrapper.append(
          lWidgetContainer,
        ),
      ),
    );
  }

  function validateWidget(pApplication, pWidget, pLibrary) {
    const lValidation = { isValid: true, reason: '' };
    const lProps = pWidget.getProps();

    switch (pWidget.getType()) {
      case 'label':
        break;
      case 'eventButton':
        if (!lProps.eventTopic) {
          lValidation.reason = 'This widget has not been configured. Please configure.';
          lValidation.isValid = false;
        }
        break;
      case 'console':
        break;
      case 'variableDisplay':
      case 'numericInput':
      case 'dropdown':
        if (!lProps.variable) {
          lValidation.reason  = 'This widget is not attached to any variable. Please configure.';
          lValidation.isValid = false;
        }
        else if (!pApplication.getParametersObject().listParametersNameOfType(['const']).includes(lProps.variable)) {
          lValidation.reason  = 'The variable this widget was attached to has been deleted. Please reconfigure.';
          lValidation.isValid = false;
        }
        break;
      case 'digitalInputDisplay':
        if (!lProps.input) {
          lValidation.reason = 'This widget is not attached to any input. Please configure.';
          lValidation.isValid = false;
        } else if (!pLibrary.getConfigManager().listInputs().map(function(pInput) { return pInput.getName(); }).includes(lProps.input)) {
          lValidation.reason  = 'The input this widget was attached to has been deleted. Please reconfigure.';
          lValidation.isValid = false;
        }
        break;
      case 'custom':
        break;
      default:
        lValidation.isValid = false;
        lValidation.reason = 'Unknown widget type';
        break;
    }

    return lValidation;
  }

  // Simply renders widgets, with absolutely no callbacks or actions attached. These can be attached
  // with differing purposes by both the editor and the player.
  function renderWidget(pApplication, pUi, pWidget, pWidgetIndex, pLibrary) {
    const lStyles = pWidget.getStyles();
    const lProps = pWidget.getProps();
    let lElement;
    const lValidationResult = validateWidget(pApplication, pWidget, pLibrary);

    switch (pWidget.getType()) {
      case 'label': {
        const lLabelElement = $('<label>').text(lProps.label || '').attr('title', lProps.label).css({width: "95%", textOverflow: "ellipsis", overflow: "hidden", textAlign: "center", overflowY: "auto", marginBottom: "0px", fontWeight : lStyles.fontWeight });
        lElement = $('<div class="ml_ui_builder_label">').css(lStyles).append(lLabelElement);
        break;
      }
      case 'eventButton': {
        lElement = $('<div>').addClass('ml_ui_builder_button').addClass('ml_ui_builder_button_active').css(lStyles)
          .append($('<div>').addClass('ml_ui_builder_button_inner_container').text(lProps.label || ''));
        break;
      }
      case 'variableDisplay': {
        const lVariableDisplayWidget = widgets.stringWidget(lProps.label || '', undefined, '', undefined, undefined, {labelTransformFunction: function(pName) { return pName; }});
        lVariableDisplayWidget.find('input').addClass('ml_ui_builder_variable_display_text_field').attr('placeholder', 'To display when available').attr('disabled', 'true').css({pointerEvents: 'none', backgroundColor: "transparent", marginBottom: "0px"});
        lElement = $('<div>').css(lStyles);
        lElement.append(lVariableDisplayWidget);
        break;
      }
      case 'digitalInputDisplay': {
        const lDigitalInputDisplayWidget = widgets.stringWidget(lProps.label || '', undefined, '', undefined, undefined, {labelTransformFunction: function(pName) { return pName; }});
        lDigitalInputDisplayWidget.find('input').addClass('ml_ui_builder_variable_display_text_field').attr('placeholder', 'To display when available').attr('disabled', 'true').css({pointerEvents: 'none', backgroundColor: "transparent", marginBottom: "0px"});
        lElement = $('<div>').css(lStyles);
        lElement.append(lDigitalInputDisplayWidget);
        break;
      }
      case 'console': {
        lElement = $('<div>').addClass('ml_ui_builder_console').css(lStyles);
        if (pUi.useFullUiSpace()) {
          lElement.addClass('full_length_ui');
        }
        const lConsoleTitle = $('<label>').text('Information Console').css({color: "white", fontSize: "16px", marginBottom: "0px", fontWeight: "normal"});
        const lInfoMessages = {
          "Info" : {icon: icons.infoCircle, color: "#1C344F"},
          "Warning" : {icon: icons.bell, color: "#667A99"},
          "Error" : {icon: icons.exclamationCircle, color: "#D9534F"},
        };
        const lConsoleInfoContainer = $('<div/ class="ml_ui_builder_console_info_container">');
        Object.keys(lInfoMessages).forEach(function(pMsg){
          const lConsoleInfoIcon = $('<div class="' + lInfoMessages[pMsg].icon + '"/>');
          const lConsoleInfoText = $('<label>').text(pMsg);
          const lConsoleInfo = $('<div class= "ml_ui_builder_console_info_tile" />').append([lConsoleInfoIcon, lConsoleInfoText]).css("background-color",lInfoMessages[pMsg].color);
          lConsoleInfoContainer.append(lConsoleInfo);
        });
        const lConsoleHeader = $('<div class="ml_ui_builder_console_header"/>').append([lConsoleTitle, lConsoleInfoContainer]);
        const lConsoleBody = $('<div class="ml_ui_builder_console_body"/>')
          .append($('<div>Output messages created from Visual Sequences will be shown here</div>').css({color: "#CECECE", fontFamily: "Larsseit, Lato, Arial",  fontStyle: "italic", fontSize: "15px" }));
        lElement.append([lConsoleHeader, lConsoleBody]);
        break;
      }
      case 'numericInput': {
        let lTooltip = '';
        if (lProps.min && lProps.max) {
          lTooltip =  "Enter number in range " + lProps.min + " and " + lProps.max;
        } else if (lProps.min) {
          lTooltip =  "Enter number greater than " + lProps.min;
        } else if (lProps.max) {
          lTooltip =  "Enter number less than " + lProps.max;
        } else {
          lTooltip = '';
        }
        const lNumericInput = widgets.numberWidget(lProps.label || '', lTooltip, lProps.defaultValue, null, {min: lProps.min, max: lProps.max, labelTransformFunction: function(pName) { return pName; }}, null);
        lNumericInput.find('input').css({textAlign: "left"});
        lNumericInput.find('.ml_parameter_widget').css({marginBottom: "0px"});
        lElement = $('<div>').addClass('ml_ui_builder_text_input').css(lStyles);
        lElement.append(lNumericInput);
        break;
      }
      case 'dropdown': {
        const lSelectInput =  widgets.listWidget(lProps.label || '', lProps.options, 'Choose a value to set to the variable', lProps.options[0], null, null, function(pName) { return pName; });
        lSelectInput.find('.ml_parameter_widget').css({marginBottom: "0px"});
        lElement = $('<div>').addClass('ml_ui_builder_text_input').css(lStyles);
        lElement.append(lSelectInput);
        break;
      }
      case 'custom': {
        lElement = $('<div class="ml_ui_builder_label">').css(lStyles);
        break;
      }
      default:
        console.error('Attempting to display unknown widget: ', pWidget, pWidgetIndex);
        return undefined;
    }

    if (!lValidationResult.isValid) {
      const _lErrorIndicator = $('<div>').addClass('ml_ui_builder_widget_invalid').append($('<div>').addClass('fa fa-exclamation-circle'));
      if (environment.isOnPendant()) {
        _lErrorIndicator.on('click', function() {
          widgets.messageBox(lValidationResult.reason, 'info');
        });
      } else {
        _lErrorIndicator.attr('title', lValidationResult.reason);
      }
      lElement.append(_lErrorIndicator);
    }

    return lElement.addClass('ml_ui_builder_widget');
  }

  // Renders the editor on top of the baseUi.
  function renderUiEdit(pLibrary, pApplication, pUi) {
    const save = function() { pApplication.setDirty(); };
    const lBaseUi = renderUiBase(pLibrary, pApplication, pUi);
    const lRenderHelperText = function() {
      lWidgetContainer.find('.ml_ui_builder_helper_text').remove();
      lWidgetContainer.find('.ml_ui_builder_widget').length == 0 && $('<h5>').text('Drag and drop elements from below to build your custom UI')
        .css({width: 8 * gGridCellWidth + 7 * gCellGutter})
        .addClass('ml_ui_builder_helper_text').appendTo(lWidgetContainer);
    };
    const lTabBar = lBaseUi.find('.ml_ui_builder_tab_area');
    const lWidgetContainer = lBaseUi.find('.ml_ui_builder_widget_container, .ml_ui_builder_widget_container_full_length');
    $('<div class="ml_ui_builder_spacer">').appendTo(lBaseUi);
    const lWidgetToolbarContainer = $('<div>').appendTo(lBaseUi).addClass('ml_ui_builder_widget_toolbar');
    const lWidgetToolbar = $('<div>').appendTo(lWidgetToolbarContainer).addClass('h_layout').css({alignItems: "center"});
    const lUiListener = {
      onTabSelected: function() {
        lRenderHelperText();
        if (lModifyAllWidgetsForEditing) {
          lModifyAllWidgetsForEditing();
        }
      },
      onTabAdded: function(pTab, pTabIndex){
        const lTabs = lTabBar.find('.ml_ui_builder_tab');
        const lTabLabel = lTabs.eq(pTabIndex).find('div');
        const lTabInput = lTabs.eq(pTabIndex).find('input');
        lAttachHandlersToTab(lTabLabel, lTabInput, pTab);
      }
    };

    function lAttachHandlersToTab(pTabLabel, pTabInput, pTab){
      pTabLabel.dblclick(function(){
        pTabLabel.hide();
        pTabInput.show();
        pTabInput.focus();
        const val = pTabInput.val();
        pTabInput.val('');
        pTabInput.val(val);
        $(window).on('click', saveText);
      });

      function saveText() {
        pTabInput.hide();
        if (pTabInput.val().length > 0 ) {
          pTabInput.prev().show().text(pTabInput.val());
          pTab.setName(pTabInput.val());
          save();
        } else {
          pTabLabel.show();
        }
        $(window).off('click', saveText);
      }

      pTabInput.on('click', function(e){e.stopPropagation();});

      pTabInput.keypress(function(e){
        if(e.keyCode == 13){
          saveText();
        }
      });
    }

    const lTabs = lTabBar.find('.ml_ui_builder_tab');
    lTabs.each(function(pTabIndex, pTabElement){
      const lTabLabel = $(pTabElement).find('div');
      const lTabInput = $(pTabElement).find('input');
      const pTab = pUi.getTabByIndex(pTabIndex);
      lAttachHandlersToTab(lTabLabel, lTabInput, pTab);
    });

    pUi.addListener(lUiListener);
    lRenderHelperText();

    // Tab Editor
    // Add default tab if we need to
    if (pUi.listTabs().length === 0) {
      pUi.addTab();
      save();
    }

    // Modify existing tabs
    const lModifyTabWithEditFunctionality = function(pTabElement) {
      if (pTabElement.index() === 0) {
        return; // First tab can never be deleted
      }

      pTabElement.css('justify-content', 'space-between');


      const lDeleteTabButton = $('<button>').append($('<i>').addClass('fal fa-times')).addClass('ml_ui_builder_delete_tab').on('click', function(pEvent) {
        pEvent.stopPropagation();
        renderDeleteModal('Do you really want to delete this tab? This process cannot be undone.',
          function() {
            pUi.removeTab(pTabElement.index());
            // show add button if we are still under max tab limit
            pUi.listTabs().length < 5 && lAddTabButton.show();
            save();}, null);
      });
      pTabElement.append(lDeleteTabButton);
    };

    lTabBar.children().each(function(pTabIndex, pTabElement) { lModifyTabWithEditFunctionality($(pTabElement)); });

    // Add tab button
    const lAddTabButton = $('<button>').append($('<i>').addClass('fal fa-plus')).addClass('ml_tab_add_button').on('click', function() {
      pUi.addTab();
      const lAddedTabElement = lTabBar.children().eq(pUi.listTabs().length - 1);
      lAddedTabElement.appendTo(lTabBar); // Move + tab to the end
      lModifyTabWithEditFunctionality(lTabBar.children().eq(pUi.listTabs().length - 1));
      // hide add button if we reach max tabs
      pUi.listTabs().length == 5 && lAddTabButton.hide();
      save();
    });
    lTabBar.append(lAddTabButton);
    pUi.listTabs().length == 5 && lAddTabButton.hide();


    // Widget Group Editor
    // Step 1: Edit styling on widgets to prepare for editing (add wheel, resizability, etc.) This will get updated whenever a user changes tabs.
    const lModifyWidgetForEditing = function(pTab, pWidget, pRenderedWidgetItem) {
      const lWheelWidget = $('<button>').addClass('ml_widget_edit_button').append($('<div>').addClass('far fa-cog')).on('click', function(pEvent) {
        const lWidgetContextMenu = widgets.contextMenu();
        lWidgetContextMenu.addClass('ml_widget_edit_contextmenu');
        pEvent.preventDefault();
        pEvent.stopPropagation();

        if (pWidget.mType !== 'console') { // If an element isn't configurable modify this conditional
          lWidgetContextMenu.addItem('Configure', function() {
            renderWidgetEditorModal(pLibrary, pApplication, pWidget, function() {
              save();

              // Update the display of the widget
              const lTabIndex = lBaseUi.getActiveTabIndex();
              const lActiveTab = pUi.getTabByIndex(lTabIndex);
              const lWidgetIndex = lActiveTab.getWidgetIndex(pWidget);
              const lNewWidgetRender = renderWidget(pApplication, pUi, pWidget, lWidgetIndex, pLibrary);

              pRenderedWidgetItem.replaceWith(lNewWidgetRender);
              lModifyWidgetForEditing(lActiveTab, pWidget, lNewWidgetRender);
            });
          });
        }

        lWidgetContextMenu.addItem('Delete', function() {
          renderDeleteModal('Do you really want to delete this widget? This process cannot be undone.', function(){ pTab.removeWidget(pWidget); pRenderedWidgetItem.remove(); lRenderHelperText(); save();}, function(){lRenderHelperText();});

        });

        lWidgetContextMenu.show(pEvent.pageX + 10, pEvent.pageY - 5);
        lWidgetContextMenu.css({ 'z-index': 9999 });
      });

      const lResizeWidgetIcon = $('<div>').addClass('ml_widget_resize_icon').append($('<div>')).addClass(icons.uiResizeIcon);
      const lMoveWidgetIcon = $('<div>').addClass('ml_widget_grab_icon').append($('<div>')).addClass(icons.uiDragIcon);
      pRenderedWidgetItem.append([lWheelWidget, lResizeWidgetIcon, lMoveWidgetIcon]).addClass('ml_draggable_widget');
      pRenderedWidgetItem.attr('disabled', true);

      //modify widgets that have different behaviour in edit mode
      //labels
      lWidgetContainer.find('.ml_ui_builder_label').css({backgroundColor: "white", border: "1px solid #CFCFCF", });
      //buttons
      lWidgetContainer.find('.ml_ui_builder_button').removeClass('ml_ui_builder_button_active').off('click');
      lWidgetContainer.find('.ml_ui_builder_button').css({cursor: "default"});
      //inputs
      lWidgetContainer.find('.ml_ui_builder_text_input').find('input').attr('disabled', 'disabled').removeAttr('title');
      lWidgetContainer.find('.ml_ui_builder_text_input').find('input').parent().css({backgroundColor: "rgb(251, 251, 251);", opacity: "0.7"});
      //selects
      lWidgetContainer.find('.ml_ui_builder_text_input').find('select').parent().addClass('ml_select_greyout_chevron');
      lWidgetContainer.find('.ml_ui_builder_text_input').find('select').attr('disabled', 'disabled').removeAttr('title');
      lWidgetContainer.find('.ml_ui_builder_text_input').find('select').parent().css({backgroundColor: "rgb(251, 251, 251);"});


      pRenderedWidgetItem.draggable({
        handle: ".ml_widget_grab_icon",
        delay: 150,
        cancel: false,
        start: function() {
          $(this).hide();
          _lWidgetDragEvent = {
            type: 'move',
            widget: pWidget,
            renderedWidget: pRenderedWidgetItem
          };
        },
        stop: function() {
          $(this).show();
          const _lDraggedWidgetStyles = pWidget.getStyles();
          $(this).css('left', _lDraggedWidgetStyles.left).css('top', _lDraggedWidgetStyles.top);
        },
        revert: "invalid" ,
        helper: 'clone',
        appendTo: 'body',
        scroll: false,
        zIndex: 1000,
        opacity: 0.5,
      });

      // Resizability behavior on widget
      pRenderedWidgetItem.resizable({
        grid: [ gGridCellWidth + gCellGutter, gGridCellHeight + gCellGutter ],
        start: function( event, ui ) {
          ui.originalSize.height = parseFloat( $( this ).css( "height" ) );
          ui.originalSize.width = parseFloat( $( this ).css( "width" ) );
        },
        stop: function(pEvent, pUi) {
          const lNewWidgetDimensions = {
            top: parseInt(pWidget.getStyles().top),
            left: parseInt(pWidget.getStyles().left),
            bottom: parseInt(pWidget.getStyles().top) + pUi.size.height,
            right: parseInt(pWidget.getStyles().left) + pUi.size.width
          };

          // if width combined height or width execeds canvas or if collision occurs do not save changed and revert UI
          if (lNewWidgetDimensions.right <= (gGridCellWidth * gGridWidth + gCellGutter * (gGridWidth - 1)) &&
                lNewWidgetDimensions.bottom <= (gGridCellHeight * gGridHeight + gCellGutter * (gGridHeight - 1)) &&
                checkForCollision(pWidget, lNewWidgetDimensions)) {
            pWidget.setDimension(pUi.size.width, pUi.size.height);
            save();
          } else {
            pUi.element.css(pUi.originalSize);
          }
        },
        containment: lBaseUi.find('.ml_ui_builder_widget_area, .ml_ui_builder_widget_area_full_length'),
        // set max and min params if specified
        maxHeight: machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].maxHeight > 1 ? gGridCellHeight * machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].maxHeight + gCellGutter * (machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].maxHeight - 1) : gGridCellHeight,
        minHeight: machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].minHeight > 1 ? gGridCellHeight * machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].minHeight + gCellGutter * (machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].minHeight - 1) : gGridCellHeight,
        maxWidth: machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].maxWidth > 1 ? gGridCellWidth * machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].maxWidth + gCellGutter * (machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].maxWidth - 1) : gGridCellWidth,
        minWidth: machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].minWidth > 1 ? gGridCellWidth * machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].minWidth + gCellGutter * (machinelogic.gUiWidgetDimensionsConstraints[pWidget.getType()].minWidth - 1) : gGridCellWidth,
        classes: {
          "ui-resizable-se": null
        }
      });
    };
    const lModifyAllWidgetsForEditing = function() {
      const lTabIndex = lBaseUi.getActiveTabIndex();
      const lCurrentTab = pUi.getTabByIndex(lTabIndex);
      lWidgetContainer.find('.ml_ui_builder_widget').each(function(pWidgetIndex) {
        const lWidget = lCurrentTab.getWidgetByIndex(pWidgetIndex);
        if (!lWidget) {
          console.error('Failed to find widget at index: ' + pWidgetIndex);
          return;
        }

        lModifyWidgetForEditing(lCurrentTab, lWidget, $(this));
      });
    };

    lModifyAllWidgetsForEditing(); // Called whenever we change tabs

    function checkForCollision(pWidget, lSelectedWidgetDim){
      const lActiveTab = pUi.getTabByIndex(lBaseUi.getActiveTabIndex());
      const lActiveWidgets = lActiveTab.listWidgets();
      const lWidgetIndex = pWidget ? lActiveWidgets.findIndex(function(pOtherWidget) { return pOtherWidget === pWidget; }) : undefined;
      let lIsValid = true;
      lActiveWidgets.forEach(function(lWidget, index){
        if (index != lWidgetIndex){
          const lGridWidgetStyles = lWidget.getStyles();
          const lGridWidget = {};
          // calculate dimensions of each other widget
          lGridWidget.top = parseInt(lGridWidgetStyles.top);
          lGridWidget.bottom = parseInt(lGridWidgetStyles.top) + parseInt(lGridWidgetStyles.height);
          lGridWidget.left = parseInt(lGridWidgetStyles.left);
          lGridWidget.right = parseInt(lGridWidgetStyles.left) + parseInt(lGridWidgetStyles.width);

          // check for horizontal overalap
          if (lIsValid && lSelectedWidgetDim.right > lGridWidget.left && lSelectedWidgetDim.left <= lGridWidget.left ||
            lSelectedWidgetDim.left < lGridWidget.right && lSelectedWidgetDim.right >= lGridWidget.right ||
            lSelectedWidgetDim.left > lGridWidget.left && lSelectedWidgetDim.right < lGridWidget.right)
          {
            // allow if above and allow if below
            if (lIsValid && lSelectedWidgetDim.bottom < lGridWidget.top && lSelectedWidgetDim.top < lGridWidget.top) {
              lIsValid = true;
            } else if (lIsValid && lSelectedWidgetDim.top > lGridWidget.bottom && lSelectedWidgetDim.bottom > lGridWidget.bottom) {
              lIsValid = true;
            } else {
              lIsValid = false;
            }
          }
        }
      });
      return lIsValid;
    }

    // function to check if drop selection is valid
    function isDropValid(pWidget, pItemRow, pItemCol, lCellSizeOnCreate) {

      const lCell = pWidget ? pWidget.getWidgetCellSize() : lCellSizeOnCreate;
      const lSelectedWidgetDim = {
        top: pItemRow * (gGridCellHeight + gCellGutter),
        bottom: pItemRow * (gGridCellHeight + gCellGutter) + ((lCell[0] * gGridCellHeight) + ((lCell[0] > 0 ? lCell[0] - 1 : 0) * gCellGutter)),
        left: pItemCol * (gGridCellWidth + gCellGutter),
        right: pItemCol * (gGridCellWidth + gCellGutter) + ((lCell[1] * gGridCellWidth) + ((lCell[1] > 0 ? lCell[1] - 1 : 0) * gCellGutter))
      };

      // checking for collision with other widgets on page
      let lIsValid = checkForCollision(pWidget, lSelectedWidgetDim);

      // Check if droppable is within limits
      lIsValid = (lIsValid && lCell[0] + pItemRow <= gGridHeight && lCell[1] + pItemCol <= gGridWidth) ? true : false;

      return lIsValid;

    }

    // Steps 2: Display the grid and define droppable behavior
    let _lWidgetDragEvent = undefined;
    const lCreateGridItem = function(pItemRow, pItemCol) {
      const lGridItem = $('<div>').addClass('ml_ui_builder_grid_item')
        .css('width', gGridCellWidth + 'px').css('height', gGridCellHeight + 'px');

      lGridItem.droppable({
        accept: '.ml_draggable_widget',
        tolerance: 'pointer',
        drop: function() {
          const lTabIndex = lBaseUi.getActiveTabIndex();
          const lActiveTab = pUi.getTabByIndex(lTabIndex);

          if (!lActiveTab) {
            console.error('Attempting to drop on an invalid tab');
            return;
          }

          const lWidgetIndex = lActiveTab.listWidgets().length;
          const lLeft = (pItemCol * gGridCellWidth) + (pItemCol * gCellGutter);
          const lTop = (pItemRow * gGridCellHeight) + (pItemRow * gCellGutter);


          switch (_lWidgetDragEvent.type) {
            case 'create': {
              const lCellSizeOnCreate = _lWidgetDragEvent.widgetType == 'console' ? [3,6] : [1,2];
              // drop if valid
              if (isDropValid(null, pItemRow, pItemCol, lCellSizeOnCreate)) {
                lWidgetContainer.find('.ml_ui_builder_helper_text').remove();
                lActiveTab.addWidget(_lWidgetDragEvent.widgetType, lWidgetIndex);
                const lNewWidget = lActiveTab.getWidgetByIndex(lWidgetIndex);
                lNewWidget.setPosition(lLeft, lTop);
                const lNewWidgetRender = renderWidget(pApplication, pUi, lNewWidget, lWidgetIndex, pLibrary);
                lWidgetContainer.append(lNewWidgetRender);
                lModifyWidgetForEditing(lActiveTab, lNewWidget, lNewWidgetRender);
                if (lNewWidget.getType() != 'console') {
                  renderWidgetEditorModal(pLibrary, pApplication, lNewWidget, function() {
                    save();
                    // Update the display of the widget
                    const lTabIndex = lBaseUi.getActiveTabIndex();
                    const lActiveTab = pUi.getTabByIndex(lTabIndex);
                    const lWidgetIndex = lActiveTab.getWidgetIndex(lNewWidget);
                    const lUpdatedWidgetRender = renderWidget(pApplication, pUi, lNewWidget, lWidgetIndex, pLibrary);
                    lNewWidgetRender.replaceWith(lUpdatedWidgetRender);
                    lModifyWidgetForEditing(lActiveTab, lNewWidget, lUpdatedWidgetRender);
                  });
                }
              } else {
                console.warn('Cannot fit widget');
              }
              // remove hover effects
              lWidgetContainer.find('.ml_ui_builder_hover_shadow').remove();
              break;
            }
            case 'move': {
              const _lDraggedWidget = _lWidgetDragEvent.widget;
              // drop if valid
              isDropValid(_lDraggedWidget, pItemRow, pItemCol) ? _lDraggedWidget.setPosition(lLeft, lTop) : console.log('Cannot fit widget');
              // remove hover effects
              lWidgetContainer.find('.ml_ui_builder_hover_shadow').remove();
              break;
            }
          }

          save();
        },

        over: function() {
          const lLeft = (pItemCol * gGridCellWidth) + (pItemCol * gCellGutter);
          const lTop = (pItemRow * gGridCellHeight) + (pItemRow * gCellGutter);
          let lHoverBox = null;
          switch (_lWidgetDragEvent.type) {
            case 'create': {
              const lCellSizeOnCreate = _lWidgetDragEvent.widgetType == 'console' ? [3,6] : [1,2];
              lHoverBox = $('<div class="ml_ui_builder_hover_shadow">').css({
                height: lCellSizeOnCreate[0] * gGridCellHeight + (lCellSizeOnCreate[0] == 1 ? 0 : (lCellSizeOnCreate[0] - 1) * gCellGutter ),
                width: lCellSizeOnCreate[1] * gGridCellWidth + (lCellSizeOnCreate[1] == 1 ? 0 : (lCellSizeOnCreate[1] - 1) * gCellGutter ),
                top: lTop,
                left: lLeft,
              });
              !isDropValid(null, pItemRow, pItemCol, lCellSizeOnCreate) && lHoverBox.addClass('ml_ui_builder_hover_invalid');
              lHoverBox.appendTo(lWidgetContainer);
              break;
            }
            case 'move': {
              const _lDraggedWidget = _lWidgetDragEvent.widget;
              lHoverBox = $('<div class="ml_ui_builder_hover_shadow">').css({
                height: _lDraggedWidget.getStyles().height,
                width: _lDraggedWidget.getStyles().width,
                top: lTop,
                left: lLeft,
              });
              !isDropValid(_lDraggedWidget, pItemRow, pItemCol) && lHoverBox.addClass('ml_ui_builder_hover_invalid');
              lHoverBox.appendTo(lWidgetContainer);
              break;
            }
          }
        },
        out: function() {
          lWidgetContainer.find('.ml_ui_builder_hover_shadow').remove();
        }
      });

      return lGridItem;
    };

    lWidgetContainer.addClass('ml_ui_builder_grid_container').css('grid-column-gap', gCellGutter).css('grid-row-gap', gCellGutter);
    for (let lGridRow = 0; lGridRow < gGridHeight; lGridRow++) {
      for (let lGridCol = 0; lGridCol < gGridWidth; lGridCol++) {
        lWidgetContainer.append(lCreateGridItem(lGridRow, lGridCol));
      }
    }

    // Step 3: Display the widget toolbar
    const lCreateToolbarItem = function(pLabel, pWidgetType) {
      const lToolbarItem = $('<div>').addClass('ml_ui_builder_widget_toolbar_item ml_draggable_widget');
      const lToolbarItemText = $('<label>').text(pLabel).css({fontWeight: "normal"});
      let lToolbarWidgetRender = null;

      switch(pWidgetType) {

        case 'console': {
          const lConsoleInfoContainer = $('<div/>').css({display: "flex"});
          const lInfoColors = ['#1C344F', '#667A99', '#D9534F', '#667A99'];
          lInfoColors.forEach(function(color) {
            const lInfoCircle = $('<div/>').css({backgroundColor: color, height: "6px", width: "14px", borderRadius: "4px", marginRight: "2px", border: "1px solid #FFFFFF"});
            lConsoleInfoContainer.append(lInfoCircle);
          });
          const lConsoleHeaderTitle = $('<label/>').text('Information Console').css({fontSize: "6px", color: "white", marginBottom: "0px", fontWeight: "normal"});
          const lConsoleHeader = $('<div/>').css({height: "20%", backgroundColor: "#1C344F", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0px 2px"}).append([lConsoleHeaderTitle, lConsoleInfoContainer]);

          const lConsoleBody = $('<div/>').css({height: "80%", padding: "2px"});
          lInfoColors.forEach(function(color) {
            const lConsoleLogLine = $('<div/>').css({height: "6px", width: "120px", borderRadius: "3px", marginLeft: "4px", backgroundColor: "#D4D4D4", marginTop: "2px"});
            const lConsoleLogCirlce = $('<div/>').css({height: "6px", width: "6px", borderRadius: "3px", border: "1px solid " + color});
            const lConsoleLog = $('<div/>').css({marginBottom: "4px", display: "flex", alignItems: "center"}).append([lConsoleLogCirlce, lConsoleLogLine]);

            lConsoleBody.append(lConsoleLog);
          });

          lToolbarWidgetRender = $('<div/>').css({border: "1px solid grey", borderRadius: "2px"}).append([lConsoleHeader, lConsoleBody]);
          break;
        }

        case 'label': {
          const lLabelText = $('<label/>').text('Add a heading title, or subtext').css({fontSize: "16px", fontWeight: "600", textAlign: "center", border: "none", padding: "0px 10px"});
          lToolbarWidgetRender = $('<div/>').css({display: "flex", justifyContent: "center", alignItems: "center"}).append(lLabelText);
          break;
        }

        case 'variableDisplay': {
          const lVDLabel = $('<label/>').text('Variable Display').css({fontSize: "12px", fontWeight: "700"});
          const lVDInputBoxText = $('<div/>').text('15').css({fontSize: "14px", fontWeight: "normal", width: "100%", textAlign: "center", border: "1px solid #CFCFCF", height: "35px", borderRadius: "2px", display: "flex", justifyContent: "center", alignItems: "center"});
          lToolbarWidgetRender = $('<div/>').css({ alignItems: "start", textAlign: "start"}).append([lVDLabel, lVDInputBoxText]);
          break;
        }

        case 'digitalInputDisplay': {
          const lDIDLabel = $('<label/>').text('Digital Input Display').css({fontSize: "12px", fontWeight: "700"});
          const lDIDInputBoxText = $('<div/>').text('1').css({fontSize: "14px", fontWeight: "normal", width: "100%", textAlign: "center", border: "1px solid #CFCFCF", height: "35px", borderRadius: "2px", display: "flex", justifyContent: "center", alignItems: "center"});
          lToolbarWidgetRender = $('<div/>').css({ alignItems: "start", textAlign: "start"}).append([lDIDLabel, lDIDInputBoxText]);
          break;
        }

        case 'numericInput' :
        case 'dropdown' : {
          const lVILabel = $('<label/>').text('Variable Input').css({fontSize: "12px", fontWeight: "700"});
          const lVIInputBoxText = $('<label/>').text('15').css({fontSize: "14px", marginLeft: "6px", marginTop: "5px", fontWeight: "normal"});
          const lVIInputBox = $('<div/>').css({width: "98%", height: "35px", border: "1px solid #CFCFCF", borderRadius: "2px", display: "flex", alignItems: "center", justifyContent: "space-between"}).append([lVIInputBoxText]);
          lToolbarWidgetRender = $('<div/>').css({ alignItems: "start", textAlign: "start"}).append([lVILabel, lVIInputBox]);
          break;
        }

        case 'eventButton': {
          const lButtonLabel = $('<label/>').text('Button').css({color: "white", fontSize: '14px'});
          const lButtonInner = $('<div/>').css({border: "1px solid #14A762", borderRadius: "3px", height: "80%", width: "90%", display: "flex", alignItems: "center", justifyContent: "center"}).append(lButtonLabel);
          lToolbarWidgetRender = $('<div/>').css({backgroundColor: "#1AC876", display: "flex", borderRadius: "3px", alignItems: "center", justifyContent: "center"}).append(lButtonInner);
          break;
        }
        default: {
          lToolbarWidgetRender = $('<div/>').css({backgroundColor: "#1AC876", display: "flex", justifyContent: "center", alignItems: "center"});
          break;
        }
      }

      if (!lToolbarWidgetRender) {
        console.error('Unable to render the toobar item for the widget: ' + pWidgetType);
        return undefined;
      } else {
        lToolbarWidgetRender.css('position', 'relative').css('width', '98%').css('height', '98%');
      }

      lToolbarItem.append($('<div class="ml_ui_builder_widget_toolbar_preview">').append(lToolbarWidgetRender));
      lToolbarItem.append(lToolbarItemText);

      lToolbarItem.draggable({
        start: function() {
          _lWidgetDragEvent = {
            type: 'create',
            widgetType: pWidgetType
          };
        },
        containment: lBaseUi,
        revert: "invalid" ,
        helper: function(){
          return $(this).clone().css('cursor', 'move');
        },
        appendTo: 'body',
        scroll: false,
        zIndex: 1000,
      });

      return lToolbarItem;
    };
    $('<label>').text('Construct your UI:').css({fontSize: "15px", padding: "0.4rem 0.2rem"}).prependTo(lWidgetToolbarContainer),
    lWidgetToolbar.append(lCreateToolbarItem('Information Console', 'console'));
    lWidgetToolbar.append(lCreateToolbarItem('Button', 'eventButton'));
    lWidgetToolbar.append(lCreateToolbarItem('Variable Input', 'numericInput'));
    lWidgetToolbar.append(lCreateToolbarItem('Variable Display', 'variableDisplay'));
    lWidgetToolbar.append(lCreateToolbarItem('Digital Input Display', 'digitalInputDisplay'));
    lWidgetToolbar.append(lCreateToolbarItem('Label', 'label'));

    lBaseUi.exit = function() {
      pUi.removeListener(lUiListener);
    };

    return lBaseUi;
  }

  // Helper functions for editor
  function getVariableSelector(pApplication, pDefaultValue, pOnChange) {
    const lParameterNameList = [null].concat(pApplication.getParametersObject().listParametersNameOfType(['const']).map(function(pName) {
      return { value: pName, text: pName };
    }));

    return widgets.listWidget('Variable to link:', lParameterNameList, '', pDefaultValue || 'null', pOnChange);
  }

  function getColorSelector(pLabel, pOptions, pDefaultValue, pOnChange) {
    const lWrapper = $('<div>').addClass('ml_ui_builder_color_picker');
    const lLabel = $('<h5>').text(pLabel);
    const lColorContainer = $('<ul>');

    pOptions.forEach(function(pColorOption) {
      const lColorOptionElement = $('<li>');
      const lColorOptionButton = $('<button>').css('background-color', pColorOption).appendTo(lColorOptionElement).on('click', function() {
        pOnChange(pColorOption);
        lColorContainer.find('> li > button > i').css('visibility', 'hidden');
        lSetSelected();
      });
      const lColorButtonCheck = $('<i>').addClass('fal fa-check-circle').appendTo(lColorOptionButton).css('visibility', 'hidden');
      const lSetSelected = function() {
        lColorButtonCheck.css('visibility', 'visible');
      };
      if (pDefaultValue === pColorOption) {
        lSetSelected();
      }

      lColorContainer.append(lColorOptionElement);
    });

    lWrapper.append(lLabel);
    lWrapper.append(lColorContainer);
    return lWrapper;
  }

  function getModalHeader(lWidget) {
    switch (lWidget.getType()) {
      case 'numericInput':
      case 'dropdown':
        return 'Variable Input';
      default: return widgets.camelCaseToText(lWidget.getType());
    }
  }


  function getValidationFunction(lEditableWidget, pApplication, pWidget, pLibrary){

    function lGetVariableListSetbyWidgets(){
      const lVariableList = [];
      const lUI = pApplication.getUi();
      lUI.listTabs().forEach(function(pTab){
        const lSetVariableWidgets = pTab.listWidgets().filter(widget=> (widget.getType() == "numericInput" || widget.getType() == "dropdown") && widget != pWidget);
        lSetVariableWidgets.forEach(function(widget){widget.getProps().variable && lVariableList.push(widget.getProps().variable);});
      });
      return lVariableList;
    }

    switch(lEditableWidget.getType()){
      case 'variableDisplay': return function() {
        const lProps = lEditableWidget.getProps();
        const lErrorMessage = [];
        if ( lProps.variable == null || pApplication.getParametersObject().isValidParameter(lProps.variable)) {
          if (pApplication.getParametersObject().listParametersNameOfType(['const']).length == 0) {
            lErrorMessage.push('Create a variable in Step 2: Visual Sequence to link');
          } else {
            lErrorMessage.push('Select a variable from the "Variable to link" dropdown menu');
          }
        }
        return lErrorMessage;
      };

      case 'digitalInputDisplay': return function() {
        const lProps = lEditableWidget.getProps();
        const lErrorMessage = [];
        if (lProps.input == null || !pLibrary.getConfigManager().listInputs().map(function(pInput) { return pInput.getName(); }).includes(lProps.input)) {
          if (pLibrary.getConfigManager().listInputs().length == 0) {
            lErrorMessage.push('Create a input in Step 1: Configure to link');
          } else {
            lErrorMessage.push('Select a input from the "Digital input to link" dropdown menu');
          }
        }
        return lErrorMessage;
      };

      case 'numericInput': return function() {
        const lProps = lEditableWidget.getProps();
        const lErrorMessage = [];
        if (lGetVariableListSetbyWidgets().includes(lProps.variable)) {
          lErrorMessage.push('Variable already being set by another variable input widget');
        }
        if (lProps.variable == null || pApplication.getParametersObject().isValidParameter(lProps.variable)) {
          if (pApplication.getParametersObject().listParametersNameOfType(['const']).length == 0) {
            lErrorMessage.push('Create a variable in Step 2: Visual Sequence to link');
          } else {
            lErrorMessage.push('Select a variable from the "Variable to link" dropdown menu');
          }
        }
        if (lProps.defaultValue !== 0 && lProps.defaultValue == '') {
          lErrorMessage.push('Default value is required');
        }
        if ((lProps.max != null) && (lProps.defaultValue > lProps.max)) {
          lErrorMessage.push('Default value must lower than max value');
        }
        if ((lProps.min != null) && (lProps.defaultValue < lProps.min)) {
          lErrorMessage.push('Default value must greater than min value');
        }
        return lErrorMessage;
      };

      case 'dropdown': return function() {
        const lProps = lEditableWidget.getProps();
        const lErrorMessage = [];
        if (lGetVariableListSetbyWidgets().includes(lProps.variable)) {
          lErrorMessage.push('Variable already being set by another variable input widget');
        }
        if (lProps.variable == null || pApplication.getParametersObject().isValidParameter(lProps.variable)) {
          if (pApplication.getParametersObject().listParametersNameOfType(['const']).length == 0) {
            lErrorMessage.push('Create a variable in Step 2: Visual Sequence to link');
          } else {
            lErrorMessage.push('Select a variable from the "Variable to link" dropdown menu');
          }
        }
        if (lProps.options.length == 0) {
          lErrorMessage.push('Options list cannot be empty.');
        } else {
          lProps.options.forEach(function(opt){
            if(isNaN(parseInt(opt))){
              lErrorMessage.push('Options list can only contain integers (' + opt + ').');
            }
          });
        }
        return lErrorMessage;
      };
      case 'eventButton': return function() {
        const lProps = lEditableWidget.getProps();
        const lErrorMessage = [];
        if(lProps.eventTopic == '') {
          lErrorMessage.push('Please enter a topic.');
        }
        return lErrorMessage;
      };

      default: return function() {
        return [];
      };
    }
  }

  function renderDeleteModal(pMessage, pOnAccept, pOnDecline){
    const lDeleteModalContainer = $('<div>').addClass('ml_modal_container').appendTo('body').hide().fadeIn(250, 'swing');
    const lDeleteModal = $('<div>').addClass('ml_modal ml_widget_editor_modal').appendTo(lDeleteModalContainer);
    const lDeleteModalBody = $('<div>').addClass('ml_widget_editor_modal_body').css({height: "80px", justifyContent: "center", paddingTop: "0px"});
    const lDeleteModalHeader = $('<div>').addClass('ml_widget_editor_modal_header').append($('<h1>').text("Are you Sure?"));
    const lDeleteModalFooter = $('<div>').addClass('ml_widget_editor_modal_footer');
    const lConfirmationLabel = $('<label/>').text(pMessage).css({width: "100%", textAlign: "center", fontSize: "14px", fontWeight: "400", marginBottom: "0"});
    const lExit = function() {
      lDeleteModalContainer.fadeOut(250, 'swing', function() {
        lDeleteModalContainer.remove();
      });
    };
    const lDeleteExitButton = $('<button>').append($('<i>').addClass('fal fa-times')).on('click', lExit);
    const lDeleteYesButton = $('<button>').css({margin: "0px 10px", backgroundColor: "#D9534F"}).text('Yes').on('click', function() {
      lDeleteModalContainer.fadeOut(250, 'swing', function() {
        lDeleteModalContainer.remove();
        pOnAccept && pOnAccept();
      });
    });
    const lDeleteNoButton = $('<button>').css({margin: "0px 10px", backgroundColor: "inherit", border: "1px solid #1C344F", color: "#1C344F"}).text('No').on('click', function() {
      lDeleteModalContainer.fadeOut(250, 'swing', function() {
        lDeleteModalContainer.remove();
        pOnDecline && pOnDecline();
      });
    });
    $('<div class="arrow-down">').css({width: 0, height: 0, borderLeft: "10px solid transparent", borderRight: "10px solid transparent", borderTop: "10px solid white", position: "absolute", top: 0}).appendTo(lDeleteModalFooter);
    lConfirmationLabel.appendTo(lDeleteModalBody);
    lDeleteModalHeader.appendTo(lDeleteModal);
    lDeleteModalBody.appendTo(lDeleteModal);
    lDeleteExitButton.appendTo(lDeleteModalHeader);
    lDeleteModalFooter.appendTo(lDeleteModal);
    lDeleteModalFooter.append([lDeleteNoButton, lDeleteYesButton]);
    lDeleteYesButton.focus();
  }

  function renderWidgetEditorModal(pLibrary, pApplication, pWidget, pOnSave) {
    const lEditableWidget = new machinelogic.UIWidget(pWidget.getType(), pWidget.toJson()); // Copy widget to prevent changes from staying on cancel
    const lTitle = getModalHeader(lEditableWidget);
    const lModalContainer = $('<div>').addClass('ml_modal_container').appendTo('body').hide().fadeIn(250, 'swing');
    const lModal = $('<div>').addClass('ml_modal ml_widget_editor_modal').appendTo(lModalContainer);
    const lModalBody = $('<div>').addClass('ml_widget_editor_modal_body').css({paddingTop: "10px"});
    const lModalHeader = $('<div>').addClass('ml_widget_editor_modal_header').append($('<h1>').text("Configure " +  lTitle));
    const lModalFooter = $('<div>').addClass('ml_widget_editor_modal_footer');
    let lWidgetContainer = $('<div>').addClass('ml_widget_editor_modal_content').appendTo(lModalBody);
    const lExit = function() {
      lEditableWidget.removeListener(lWidgetListener);
      lModalContainer.fadeOut(250, 'swing', function() {
        lModalContainer.remove();
      });
    };
    const lExitButton = $('<button>').append($('<i>').addClass('fal fa-times')).on('click', lExit);
    let lValidationFunction = null;
    const lDoneButton = $('<button>').text('Done').on('click', function() {
      const lErrorMessages = lValidationFunction();
      if (lErrorMessages.length != 0){
        lErrorMessages.forEach(function(msg){
          widgets.messageBox(msg, 'error');
        });
      } else {
        pWidget.fromJson(lEditableWidget.toJson()); // Copy the edited widget into our original
        lExit();
        pOnSave();
      }
    });
    const lWidgetListener = {
      onTypeChanged: function() {
        lUpdateModal();
      }
    };

    $('<div class="arrow-down">').css({width: 0, height: 0, borderLeft: "10px solid transparent", borderRight: "10px solid transparent", borderTop: "10px solid white", position: "absolute", top: 0}).appendTo(lModalFooter);
    lModalHeader.appendTo(lModal);
    lModalBody.appendTo(lModal);
    lExitButton.appendTo(lModalHeader);
    lModalFooter.appendTo(lModal);
    lModalFooter.append(lDoneButton);

    lEditableWidget.addListener(lWidgetListener);

    // Note (mkosarek): Whenever you need to add a new widget, you must fill in this with a rendering of its configuration options
    function lUpdateModal() {
      // Remove existing modal content and load updated fields
      lWidgetContainer.remove();
      lWidgetContainer = $('<div>').addClass('ml_widget_editor_modal_content').appendTo(lModalBody);
      // Update validation function
      lValidationFunction = getValidationFunction(lEditableWidget, pApplication, pWidget, pLibrary);

      const lProps = lEditableWidget.getProps();
      let lStyles = lEditableWidget.getStyles();

      switch (lEditableWidget.getType()) {
        case 'variableDisplay': {
          const lVarDisplayLabelEditor = widgets.stringWidget('Label:', '', lProps.label, function(pNewValue) {
            lProps.label = pNewValue;
          });
          const lVariableToLinkSelector = getVariableSelector(pApplication, lProps.variable, function(pVariableName) {
            if (pVariableName === 'null') {
              lProps.variable = null;
            } else {
              lProps.variable = pVariableName;
            }}).css({marginTop: "8px"});

          lWidgetContainer.append(lVarDisplayLabelEditor);
          lWidgetContainer.append(lVariableToLinkSelector);
          break;
        }

        case 'digitalInputDisplay': {
          const lDigitalInputDisplayLabelEditor = widgets.stringWidget('Label:', '', lProps.label, function(pNewValue) {
            lProps.label = pNewValue;
          });
          const lInputNameList = [null].concat(pLibrary.getConfigManager().listInputs().map(function(pInput) { return pInput.getName(); }).map(function(pName) {
            return { value: pName, text: pName };
          }));
          const lDigitalInputDisplayInputSelector = widgets.listWidget('Digital input to link:', lInputNameList, '', lProps.input || 'null', function(pNewValue) {
            if (pNewValue === 'null') {
              lProps.input = null;
            } else {
              lProps.input = pNewValue;
            }}).css({marginTop: "8px"});

          lWidgetContainer.append([lDigitalInputDisplayLabelEditor, lDigitalInputDisplayInputSelector]);
          break;
        }

        case 'numericInput' : {
          // Label Input Field
          const lNumericInputLabelEditor = widgets.stringWidget('Label:', '', lProps.label, function(pNewValue) {
            lProps.label = pNewValue;
          });
          // Variable Select Field
          const lNumericVarSelector = getVariableSelector(pApplication, lProps.variable, function(pVariableName) {
            if (pVariableName === 'null') {
              lProps.variable = null;
            } else {
              lProps.variable = pVariableName;
              lProps.defaultValue = pApplication.getParametersObject().getParameterValue(pVariableName);
              lNumericInputDefaultValueSelector.find('input').val(pApplication.getParametersObject().getParameterValue(pVariableName));
            }
          }).css({marginTop: "8px"});
          //Type Select Field
          const lNumericInputTypeSelector = widgets.listWidget('Type:', ['Number input', 'Predefined values'], '', 'Number input', function(pNewValue) {if(pNewValue == 'Predefined values'){lEditableWidget.setType('dropdown');}}).css({marginTop: "13px"});
          //Default Value Input Field
          const lNumericInputDefaultValueSelector = widgets.numberWidget(
            'Default value:',
            '',
            lProps.defaultValue,
            '',
            {'placeholder': "Default (required)"},
            function(pNewValue) { lProps.defaultValue = pNewValue; }
          ).css({marginTop: "13px"});
          lNumericInputDefaultValueSelector.find('input').css({textAlign: "left", padding: "0px"});
          lNumericInputDefaultValueSelector.find('div').eq(2).css({marginBottom: "3px"});
          //MinMax Input Fields
          const lMaxMinContainer = $('<div/>').addClass('h_layout').css({marginTop: "0.25rem"});
          const lNumericInputMaxInput = widgets.numberWidget('', '', lProps.max, null, {'placeholder': 'Max (Optional)'}, function(pNewValue) {lProps.max = pNewValue != null ? Number(pNewValue) : Number.POSITIVE_INFINITY;}, true);
          const lHSpacer = $('<div/>').css({width: "5px"});
          const lNumericInputMinInput = widgets.numberWidget('', '', lProps.min, null, {'placeholder': 'Min (Optional)'}, function(pNewValue) {lProps.min = pNewValue != null ? Number(pNewValue) : Number.NEGATIVE_INFINITY;}, true);
          lMaxMinContainer.append([lNumericInputMinInput, lHSpacer, lNumericInputMaxInput]);
          lWidgetContainer.append([lNumericInputLabelEditor, lNumericVarSelector, lNumericInputTypeSelector, lNumericInputDefaultValueSelector, lMaxMinContainer]);
          break;
        }

        case 'dropdown' : {
          // Label Input Field
          const lDropdownLabelEditor = widgets.stringWidget('Label:', '', lProps.label, function(pNewValue) {
            lProps.label = pNewValue;
          });
          // Variable Select Field
          const lDropdownVarSelector = getVariableSelector(pApplication, lProps.variable, function(pVariableName) {
            if (pVariableName === 'null') {
              lProps.variable = null;
            } else {
              lProps.variable = pVariableName;
            }
          }).css({marginTop: "8px"});
          // Type Select Field
          const lDropdownTypeSelector = widgets.listWidget('Type:', ['Number input', 'Predefined values'], '', 'Predefined values', function(pNewValue) {if(pNewValue == 'Number input'){lEditableWidget.setType('numericInput');}}).css({marginTop: "13px"});
          // Options Input Field
          const lDropdownOptions = widgets.stringWidget('', '', lProps.options.join(','), function(pNewValue){lProps.options = pNewValue.split(',');}).css({marginTop: "0.25rem"});
          lDropdownOptions.attr('placeholder', 'Specify ie. 2,3,4,5,6');
          const lHint = $('<p>').text('Seperate values with comma').css({padding: "0px 4px", fontSize: "10px", margin: "0px"});
          lWidgetContainer.append([lDropdownLabelEditor, lDropdownVarSelector, lDropdownTypeSelector, lDropdownOptions, lHint]);
          break;
        }

        case 'eventButton': {
          //Label Input Field
          const lEventButtonLabelEditor = widgets.stringWidget('Button label:', '', lProps.label, function(pNewValue) {lProps.label = pNewValue;});
          // Color Select Field
          const lEventButtonColorSelector = getColorSelector('Button color:', [ '#9E9E9E', '#0239EF', '#1AC876', '#D9534F', '#FF8E33' ], lStyles.backgroundColor, function(pNewColor) {lStyles.backgroundColor = pNewColor;}).css({marginTop: "8px"});
          //Topic Input Field
          const lEventButtonEventTopicInput = widgets.stringWidget('Event to generate:', '', lProps.eventTopic, function(pNewValue) {lProps.eventTopic = pNewValue;}).css({marginTop: "13px"});
          //Message Input Field
          const lEventButtonEventMessageInput = widgets.stringWidget('', '', lProps.eventMessage, function(pNewValue) {lProps.eventMessage = pNewValue;}, null, {allowEmpty: true})
            .attr('placeholder', 'Message')
            .autocomplete({source: pApplication.getUsedMessageList(), minLength: 0, select: function( event, ui ) { lProps.eventMessage = `${ui.item.value}`; } })
            .focus(function() {$(this).autocomplete('search', $(this).val());});
          //Hint Message
          const lHintMessage = $('<div>').html('Make sure you have a "Wait For Event" command in your MachineLogic application').css({width: "100%", textAlign: "center", fontSize: "11px", color: "#BFBFBF", fontStyle: "italics", lineHeight: "15px", marginTop: "13px"});

          lEventButtonEventTopicInput.find('input').attr('placeholder', 'Topic (Required)').autocomplete({source: pApplication.getUsedTopicList(), minLength: 0, select: function( event, ui ) {lProps.eventTopic = ui.item.value;} }).focus(function() {$(this).autocomplete('search', $(this).val());});

          lWidgetContainer.append([lEventButtonLabelEditor, lEventButtonColorSelector, lEventButtonEventTopicInput, lEventButtonEventMessageInput, lHintMessage]);

          break;
        }
        case 'label': {
          const lLabelLabel = widgets.stringWidget('Label:', '', lProps.label, function(pNewValue) {
            lProps.label = pNewValue;
          });
          const lLabelStylePicker = widgets.dropDownWidget('Text style: ', machinelogic.gValidStyleChoices, lProps.selectedStyle, function(pNewStyle){
            lProps.selectedStyle = pNewStyle;
            lStyles = Object.assign(lStyles, machinelogic.gValidStyleChoices[pNewStyle].css);
          }).css({marginTop: "8px"});
          lLabelStylePicker.find('div').eq(2).css({marginTop: "5px"});
          lWidgetContainer.append(lLabelLabel);
          lWidgetContainer.append(lLabelStylePicker);
          break;
        }
        default: {
          console.error('Editing is not available for widget', lEditableWidget);
          break;
        }
      }
    }

    lUpdateModal();
  }

  // Renders the player on top of the base ui
  function renderUiPlay(pLibrary, pApplication, pUI, pPlayerWidget, pInterface) {
    let lIsRunning = false;
    const _lOnStateChanged = function(pState) {
      if (pState === machinelogic.ApplicationState.RUNNING || pState === machinelogic.ApplicationState.PAUSED) {
        lOnStart();
      } else if (pState === machinelogic.ApplicationState.COMPLETED) {
        lOnComplete();
      }
    };
    const _lOnTrace = function (pTraceData) {
      // -- Custom widgets can be listening on trace data reception.
      lTraceDataReceivedCallbacks.forEach(function (pCb) { pCb(pTraceData); });

      if (!pTraceData) {
        return;
      }

      // update widgets if running
      // Variable updates
      if (pTraceData.variables) {
        Object.keys(pTraceData.variables).forEach(function(pVariableName) {
          if (lVariableChangedCallbacks[pVariableName]) {
            lVariableChangedCallbacks[pVariableName].forEach(function(pOnVarChanged) {
              pOnVarChanged(pTraceData.variables[pVariableName]);
            });
          }
        });
      }

      //io updates
      if(pTraceData.inputs) {
        for (const pControllerId in pTraceData.inputs) {
          for (const pDevice in pTraceData.inputs[pControllerId]) {
            for (const pPin in pTraceData.inputs[pControllerId][pDevice]) {
              if (lDigitalInputChangedCallbacks[pControllerId] && lDigitalInputChangedCallbacks[pControllerId][pDevice] && lDigitalInputChangedCallbacks[pControllerId][pDevice][pPin]) {
                lDigitalInputChangedCallbacks[pControllerId][pDevice][pPin].forEach(function(pOnDigitalInputChanged){
                  pOnDigitalInputChanged(pTraceData.inputs[pControllerId][pDevice][pPin]);
                });
              }
            }
          }
        }
      }

      // Logging updates
      if (pTraceData.logging) {
        pTraceData.logging.forEach(function(pStream) {
          const _lStreamName = pStream.name;
          const _lLogList = pStream.logs;
          if (lNewLogsReceivedCallbacks[_lStreamName]) {
            lNewLogsReceivedCallbacks[_lStreamName].forEach(function(pOnLogsUpdated) {
              pOnLogsUpdated(_lLogList);
            });
          }
        });
      }

      // State change checks
      if (pTraceData.state == 'running' && !lIsRunning) {
        _lOnStateChanged(pTraceData.state);
      } else if (pTraceData.state == 'completed' && lIsRunning) {
        _lOnStateChanged(pTraceData.state);
      }
    };
    const lOnStart = function() {
      lOnResetCallbacks.forEach(function(pCallback) { pCallback(); }); // Do resets before each run
      lIsRunning = true;
      lWidgetContainer.find('.ml_ui_builder_button').hasClass('disabled') && lWidgetContainer.find('.ml_ui_builder_button').removeClass('disabled');
    };
    const lOnComplete = function() {
      // Update runtime config with values in widget fields (so we persist the variable values on re-run)
      lWidgetContainer.find('.ml_ui_builder_widget').each(function(pWidgetIndex) {
        const lWidget = pUI.getTabByIndex(lBaseUi.getActiveTabIndex()).getWidgetByIndex(pWidgetIndex);
        const lWidgetElement = $(this);
        const lProps = lWidget.getProps();
        if ( lWidget.getType() == 'numericInput' ) {
          lRunTimeConfig.defaultVariableValues[lProps.variable] = lWidgetElement.find('input').val();
        } else if ( lWidget.getType() == 'dropdown') {
          lRunTimeConfig.defaultVariableValues[lWidget.getProps().variable] = lWidgetElement.find('select').val();
        }
      });
      pInterface.setRuntimeConfig(lRunTimeConfig);

      lIsRunning = false;
      lWidgetContainer.find('.ml_ui_builder_button').addClass('disabled');
    };
    const lOnResetCallbacks = [];
    const lVariableChangedCallbacks = {};
    const lNewLogsReceivedCallbacks = {};
    const lDigitalInputChangedCallbacks = {};
    const lTraceDataReceivedCallbacks = [];
    const lRunTimeConfig = {
      defaultVariableValues: (function() {
        // By default, we populate the runtime config with the values found in the UI
        const lDefaultVariableValues = {};
        const lSetDefaultValue = function(pVar, pValue) {
          lDefaultVariableValues[pVar] = pValue;
        };

        pUI.listTabs().forEach(function(pTab) {
          pTab.listWidgets().forEach(function(pWidget) {
            const lProps = pWidget.getProps();
            switch (pWidget.getType()) {
              case 'dropdown': {
                lSetDefaultValue(lProps.variable, Number(lProps.options[0]));
                break;
              }
              case 'numericInput': {
                lSetDefaultValue(lProps.variable, lProps.defaultValue);
                break;
              }
            }
          });
        });

        return lDefaultVariableValues;
      })()
    };
    const lBaseUi = renderUiBase(pLibrary, pApplication, pUI);
    const lWidgetContainer = lBaseUi.find('.ml_ui_builder_widget_container, .ml_ui_builder_widget_container_full_length');
    const lUpdateTab = function() {
      const lTabIndex = lBaseUi.getActiveTabIndex();
      const lCurrentTab = pUI.getTabByIndex(lTabIndex);

      lWidgetContainer.find('.ml_ui_builder_widget').each(function(pWidgetIndex) {
        const lWidget = lCurrentTab.getWidgetByIndex(pWidgetIndex);
        const lWidgetElement = $(this);
        if (!lWidget) {
          console.error('Failed to find widget at index: ' + pWidgetIndex);
          return;
        }

        if (lWidgetElement.find('.ml_ui_builder_widget_invalid').length > 0) {
          // Invalid widget, let's not connect any action to it
          console.warn('Encountered invalid widget at index=' + pWidgetIndex, lWidget);
          switch (lWidget.getType()) {
            case 'eventButton': {
              lWidgetElement.addClass('disabled');
              lWidgetElement.removeClass('ml_ui_builder_button_active');
              lWidgetElement.css({backgroundColor: "lightgrey"});
              break;
            }
            case 'dropdown': {
              lWidgetElement.find('select').attr('disabled', 'disabled');
              lWidgetElement.find('select').parent().css({background: 'rgb(251, 251, 251)'});
              break;
            }
            case 'numericInput': {
              lWidgetElement.find('input').attr('disabled', 'disabled');
              lWidgetElement.find('input').parent().css({background: 'rgb(251, 251, 251)'});
              break;
            }
          }
          lWidgetElement.find('div').eq(0).css({opacity: "0.4"});
          return;
        }

        lWidgetElement.addClass('ml_ui_builder_widget_active');
        // Note (mkosarek), Fill in actions here
        switch (lWidget.getType()) {
          case 'eventButton': {
            const lEventTopic = lWidget.getProps().eventTopic;
            const lEventMessage = lWidget.getProps().eventMessage;

            !lIsRunning && lWidgetElement.addClass('disabled');

            lWidgetElement.on('click', function() {
              const lMessage = lEventTopic ? ('Generated event with topic "' + lEventTopic + '"' + (lEventMessage ? ' and message "' + lEventMessage + '".' : ".")) : 'Button not configured properly';
              lWidgetElement.addClass('disabled');
              machinemotion.generateEvent(lEventTopic, `"${lEventMessage}"`, function(success) {
                lWidgetElement.removeClass('disabled');
                success && widgets.messageBox(lMessage, 'info');
              });
            });

            break;
          }
          case 'variableDisplay': {
            const lVariableName = lWidget.getProps().variable;

            const lVarDisplayTextbox = lWidgetElement.find('input');

            if (!lVariableChangedCallbacks[lVariableName]) {
              lVariableChangedCallbacks[lVariableName] = [];
            }

            lVariableChangedCallbacks[lVariableName].push(function(pValue) {
              lVarDisplayTextbox.val(pValue);
            });
            break;
          }
          case 'digitalInputDisplay': {
            const lInputName = lWidget.getProps().input;

            const lDigitalInputDisplayTextbox = lWidgetElement.find('input');

            const lInputObject = pLibrary.getConfigManager().getInputByName(lInputName);
            if (lInputObject) {
              const lControllerId = lInputObject.getControllerId();
              const lDevice = lInputObject.getDevice();
              const lPin = lInputObject.getPin();
              const lDeviceType = lInputObject.getDeviceType();

              if (!lDigitalInputChangedCallbacks[lControllerId]) { lDigitalInputChangedCallbacks[lControllerId] = {}; }
              if (!lDigitalInputChangedCallbacks[lControllerId][lDevice]) { lDigitalInputChangedCallbacks[lControllerId][lDevice] = {}; }
              if (!lDigitalInputChangedCallbacks[lControllerId][lDevice][lPin]) { lDigitalInputChangedCallbacks[lControllerId][lDevice][lPin] = []; }

              lDigitalInputChangedCallbacks[lControllerId][lDevice][lPin].push(function(pValue) {
                if (lDeviceType === 'pushButtonModule') {
                  lDigitalInputDisplayTextbox.val(pValue ? 'Pushed' : 'Released');
                }
                else {
                  lDigitalInputDisplayTextbox.val(pValue);
                }
              });
            }
            break;
          }
          case 'dropdown': {
            const lSelectElement = lWidgetElement.find('select');
            const lDropdownVar = lWidget.getProps().variable;

            if (lRunTimeConfig.defaultVariableValues[lDropdownVar] !== undefined) {
              // This ensures that the value of the input element persists between tab changes
              lSelectElement.val(lRunTimeConfig.defaultVariableValues[lDropdownVar]);
            }

            lRunTimeConfig.defaultVariableValues[lDropdownVar] = Number(lSelectElement.val());
            lSelectElement.on('change', function() {
              const lNewValue = $(this).val();

              // Always update the runtime configuration, even if we're not running, so that it is set for the next run properly.
              lRunTimeConfig.defaultVariableValues[lDropdownVar] = lNewValue;
              if (!pApplication.isActive()) {
                pInterface.setRuntimeConfig(lRunTimeConfig);
              } else {
                machinemotion.setVariable(lDropdownVar, lNewValue, function(success) {
                  success ? console.log('Succesfully updated variable ') : console.log('Unsucessfull') ;
                });
              }
            });

            break;
          }
          case 'numericInput': {
            const lInputElement = lWidgetElement.find('input');
            const lNumericVar = lWidget.getProps().variable;

            if (lRunTimeConfig.defaultVariableValues[lNumericVar] !== undefined) {
              // This ensures that the value of the input element persists between tab changes
              lInputElement.val(lRunTimeConfig.defaultVariableValues[lNumericVar]);
            }

            lRunTimeConfig.defaultVariableValues[lNumericVar] = Number(lInputElement.val());
            lInputElement.on('change', function() {
              const lNewValue = $(this).val();

              // Always update the runtime configuration, even if we're not running, so that it is set for the next run properly.
              lRunTimeConfig.defaultVariableValues[lNumericVar] = lNewValue;
              if (!pApplication.isActive()) {
                pInterface.setRuntimeConfig(lRunTimeConfig);
              } else {
                machinemotion.setVariable(lNumericVar, lNewValue, pApplication.getName(), function(success) {
                  success ? console.log('Succesfully updated variable ') : console.log('Unsucessfull') ;
                });
              }
            });

            break;
          }
          case 'console': {
            if (!lNewLogsReceivedCallbacks['console']) {
              lNewLogsReceivedCallbacks['console'] = [];
            }

            const _lGetConsoleRuntime = function() {

              let lMessages = [];

              const lWidgetBody = lWidgetElement.find('.ml_ui_builder_console_body').empty();
              const lWidgetList = $('<ul>').appendTo(lWidgetBody);
              let lIsScrolling = false;

              return {
                addMessage: function(pMessage) {
                  if(lMessages.find(item => item.id === pMessage.id)){ return; } // Message came in at the same time, and we have it
                  else { lMessages.push(pMessage); }

                  let _lLogIcon = undefined;

                  switch (pMessage.level) {
                    case 'info':
                      _lLogIcon = icons.infoCircle;
                      break;
                    case 'warning':
                      _lLogIcon = icons.bell;
                      break;
                    case 'error':
                      _lLogIcon = icons.exclamationCircle;
                      break;
                    default:
                      console.error('Unknown level', pMessage);
                      return;
                  }

                  const _lWidgetItem = $('<li>').addClass('ml_widget_console_body_item h_layout');
                  const _lWidgetItemIcon = $('<span>').addClass(`icon_display ${_lLogIcon}`);
                  const _lWidgetItemContent = $('<p>').text(pMessage.message);
                  const _lWidgetItemTimestamp = $('<span>').text(new Date(pMessage.timestamp).toLocaleString()).addClass("ml_widget_console_body_item_timestamp");

                  _lWidgetItem.append(_lWidgetItemTimestamp);
                  _lWidgetItem.append(_lWidgetItemIcon);
                  _lWidgetItem.append(_lWidgetItemContent);

                  lWidgetList.append(_lWidgetItem);

                  // scroll to the last message, disable scrolling if we scroll up, reanable when scrolling down and last message is at the bottom
                  function isAbove(el, holder) {
                    if (!el || !holder) { return false; }
                    const elRect = el.getBoundingClientRect();
                    const holderRect = holder.getBoundingClientRect();
                    return elRect.top <= holderRect.bottom;
                  }

                  lWidgetList.off('scroll');
                  const lastMessage = lWidgetList[0]?.lastElementChild;
                  if(!lIsScrolling) {
                    lastMessage?.scrollIntoView({behaviour: 'instant'});
                  }
                  window.requestAnimationFrame(() => {
                    lWidgetList.on('scroll', () => {
                      lIsScrolling = !isAbove(lastMessage, lWidgetList[0]);
                    });
                  });
                },
                reset: function () {
                  lMessages = [];
                  lWidgetList.empty();
                }
              };
            };

            const _lRuntime = _lGetConsoleRuntime();
            lOnResetCallbacks.push(_lRuntime.reset);

            lNewLogsReceivedCallbacks['console'].push(function(pNewLogs) {
              pNewLogs.forEach(_lRuntime.addMessage);
            });
            break;
          }
          case 'label': {
            break;
          }
          case 'custom': {
            const lRenderFunc = lWidget.getProps().renderFunc;
            lTraceDataReceivedCallbacks.push(function(pTraceData) {
              lRenderFunc(lWidgetElement, pTraceData);
            });

            lRenderFunc(lWidgetElement); // Call the render once without any trace data.
            break;
          }
          default: {
            console.error('Unsupported element type', lWidget);
            break;
          }
        }
      });
    };
    const lUiListener = {
      onTabSelected: lUpdateTab
    };

    lUpdateTab();
    pInterface.setRuntimeConfig(lRunTimeConfig);

    pUI.addListener(lUiListener);

    // Footer
    let lExecuteFooter = undefined;
    lBaseUi.setPlayerWidget = function(pPlayerWidget) {
      // Note (MachineApps) This function is used to dynamically swap our what player widget we are using for
      // MachineApps. We use one player widget for MachineLogic app generation, and another player widget for
      // runtime (the latter being the same player widget that everyone uses).
      if (lExecuteFooter != undefined) { lExecuteFooter.remove(); }

      lExecuteFooter = $('<div>').appendTo(lBaseUi).addClass('ml_ui_builder_play_footer h_layout justify-center');
      lExecuteFooter.append(pPlayerWidget.addClass('ml_player_no_tab'));
    };

    if (pPlayerWidget) {
      lBaseUi.setPlayerWidget(pPlayerWidget);
    }

    // Add callback to remove listener on exit
    lBaseUi.on('remove', function onRemoveBaseUi() {
      pUI.removeListener(lUiListener);
    });

    pInterface.setTraceCallback(_lOnTrace);
    pInterface.setStateChangedCallback(_lOnStateChanged);
    return lBaseUi;
  }

  /* global define */
  const gExports = {
    renderUiEdit: renderUiEdit,
    renderUiPlay: renderUiPlay
  };
  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
})();

